import { Trans } from "@lingui/react/macro"
import {
  AvatarStack,
  stackLabel,
} from "@/components/v2/assignees/avatar-stack"
import type { ContactAssignee } from "@/types/v2/contact"

// "Owner" cell — mirrors answerer-cell.tsx but for contacts
// (no AI dot). Renders the shared overlapping `AvatarStack`
// with a "+N" overflow tile and a label. The whole cell is
// the reassign trigger (opens the popover / sheet). When
// nobody is assigned it reads "Assign →".

export function ContactAssigneesCell({
  assignees,
  size = 22,
  onReassign,
}: {
  assignees: ContactAssignee[]
  size?: number
  onReassign?: () => void
}) {
  if (assignees.length === 0) {
    return (
      <button
        type="button"
        data-testid="assign-contact"
        onClick={onReassign}
        className="flex items-center gap-1.5 min-w-0 text-left cursor-pointer"
      >
        <span
          className="flex items-center justify-center shrink-0 rounded-full bg-[#C9C2B6]"
          style={{ width: size, height: size }}
        >
          <PersonGlyph />
        </span>
        <span className="font-medium text-[#B86A2D] text-[13px] leading-4">
          <Trans>Assign →</Trans>
        </span>
      </button>
    )
  }

  return (
    <button
      type="button"
      data-testid="reassign-contact"
      onClick={onReassign}
      className="flex items-center gap-1.5 min-w-0 text-left cursor-pointer rounded-md -mx-1 px-1 py-0.5 hover:bg-[#F0EDE6]"
    >
      <AvatarStack people={assignees} size={size} />
      <span className="text-[#1E1B17] text-[13px] leading-4 truncate min-w-0">
        {stackLabel(assignees)}
      </span>
    </button>
  )
}

function PersonGlyph() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="6" cy="5" r="2" stroke="#5C544A" />
      <path
        d="M2.5 10.5C2.5 8.5 4 7.5 6 7.5C8 7.5 9.5 8.5 9.5 10.5"
        stroke="#5C544A"
      />
    </svg>
  )
}
